import { render } from "./MobipassCard.vue?vue&type=template&id=41c95293&scoped=true"
const script = {}

import "./MobipassCard.vue?vue&type=style&index=0&id=41c95293&scoped=true&lang=css"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c95293"]])

export default __exports__